import { isEmpty } from 'lodash'

const onlyNumbers = (document) => {
  if (isEmpty(document)) return ''
  return document.replace(/\D/g, '')
}

export default onlyNumbers
